import $ from "jquery";

const checkout = () => {
  const init = () => {
    rate_handle();
  };

  const rate_handle = () => {
    const el = {
      target_guest: ".mphb_sc_checkout-guests-chooser",
      input_radio: ".mphb_sc_checkout-rate:checked",
      inputs_radio: ".mphb_sc_checkout-rate",
      inputs_radio_hide: ".mphb_sc_checkout-rate[data-hide=true]",
      radio_specific: "#mphb_room_details-0-rate-id-",
    };

    if ($(el.target_guest).length === 0) return;

    const rate_limiter = (target = el.input_radio) => {
      const current_guest = $(el.target_guest).val();

      const rates = parameters.rates;

      const obj = rates.find((val) => val.rate.ID == $(target).val())

      if (obj) {
        if(current_guest > obj.max) {
          $(el.input_radio).parent().parent().hide();
          $(el.input_radio).attr('data-hide', true);
          $(el.input_radio).removeAttr("checked");
          $(el.input_radio).removeAttr("name");
          $(`${el.radio_specific}${obj.rate.ID + 1}`).attr('checked', true)
        } else {
          $(el.inputs_radio_hide).each((_, el) => {
            const hide_id = $(el).val();

            const obj = rates.find((val) => val.rate.ID == hide_id)
            if (obj && current_guest <= obj.max) {
              $(el).parent().parent().show();
              $(el).attr('name','mphb_room_details[0][rate_id]');
              $(el).removeAttr("checked");
              $(el).removeAttr("data-hide");
            }
          })
        }
      }
    }

    $(document).on("change", el.target_guest, function (event) {
      rate_limiter();
    });

    $(document).on('click input', el.inputs_radio, function (event) {
      rate_limiter(event.target);
    })
  };

  init();
};

checkout();
